<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Role</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Nama Posisi">
                                <b-form-input v-model="input.namaPosisi" name="namaPosisi" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Level">
                                <b-form-input v-model="input.level" name="level" required></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="roleUpdateBtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Role" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah role ini?" @submit="onSubmit" />
    </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
    name: 'edit-role',
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            input: {
                level: ""
            },
        }
    },

    methods: {

        //----------------- Fungsi Inisialisasi -----------------
        
        init(){
            this.initStatus = 0
            this.id = this.$route.params.id
            
            let getSingleRole = this.$axios.get(`role/${this.id}`).then(response => {
                this.role = response.data

                //----------------- Inisialisasi Data Role -----------------

                this.input.namaPosisi = this.role.name
                this.input.level = this.role.level
            })

            Promise.all([getSingleRole]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        
        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

             //----------------- Append Data Role -----------------

            payload.append("id", this.id)
            payload.append("name", this.input.namaPosisi)
            payload.append("level", this.input.level)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("role/", payload).then(response => {
                this.$helper.setFlash(`Role telah berhasil diubah!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-edit")
        }

    },

    watch: {
        "input.level": function(newValue) {
            if(this.initStatus == 1){
                if(newValue.substring(0, 1) == '0'){
                    const newValueCheck = newValue.substring(1)
                    const result = newValueCheck.replace(/[^0-9]/g, "");
                    this.$nextTick(() => this.input.level = result);
                }else{
                    const result = newValue.replace(/[^0-9]/g, "");
                    this.$nextTick(() => this.input.level = result);
                }
            }
        }
    },
    
    created(){
        this.init()
    }
}
</script>
